export const womenLevelThree = [

  { name: "Sports & Active Wear", categoryId: "women_sports_active_wear", parentCategoryId: "women_active_wear", level: 3 },

  { name: "Lingerie Sleepwear", categoryId: "women_lingerie_sleepwear", parentCategoryId: "women_sleep_wear", level: 3 },
  
  { name: "Tops & T-Shirts", categoryId: "women_tops_t_shirts", parentCategoryId: "women_western_wear", level: 3 },
  { name: "Jeans & Jeggings", categoryId: "women_jeans", parentCategoryId: "women_western_wear", level: 3 },
  { name: "Dresses", categoryId: "women_dresses", parentCategoryId: "women_western_wear", level: 3 },
  { name: "Skirts", categoryId: "women_skirts", parentCategoryId: "women_western_wear", level: 3 },
  
  { name: "Flats", categoryId: "women_flats", parentCategoryId: "women_footwear", level: 3 },
  { name: "Heels", categoryId: "women_heels", parentCategoryId: "women_footwear", level: 3 },
  { name: "Sports Shoes", categoryId: "women_sports_shoes", parentCategoryId: "women_footwear", level: 3 },
  { name: "Boots", categoryId: "women_boots", parentCategoryId: "women_footwear", level: 3 },
  

  { name: "Bags", categoryId: "women_bags", parentCategoryId: "women_accessories", level: 3 },
  { name: "Jewelry", categoryId: "women_jewelry", parentCategoryId: "women_accessories", level: 3 },
  { name: "Belts", categoryId: "women_belts", parentCategoryId: "women_accessories", level: 3 },
  { name: "Scarves", categoryId: "women_scarves", parentCategoryId: "women_accessories", level: 3 },
  
  {name: "Women Jackets", categoryId: "women_jackets", parentCategoryId: "women_topwear", level: 3},
  {name: "Women Crop Tops", categoryId: "women_crop_tops", parentCategoryId: "women_topwear", level: 3}

];
